<template>
  <div class="entity key">
    <sui-form-fields>
      <EntityInput v-model="entity.name" v-autoselect fieldName="name" v-if="visibleFields.name" />
      <EntityButtons :buttons="typeButtons" v-model="entity.type" fieldName="type" v-if="visibleFields.type" />
      <EntityButtons :buttons="defaultButtons" v-model="entity.default" fieldName="default" v-if="visibleFields.default" />
    </sui-form-fields>
    <EntityText v-model="entity.key" fieldName="key" v-if="visibleFields.key" />
  </div>
</template>

<script>
  import EntityButtons from '@/components/forms/EntityButtons'
  import EntityInput from '@/components/forms/EntityInput'
  import EntityText from '@/components/forms/EntityText'
  import FormEntity from '@/mixins/FormEntity'

  export default {
    name: 'FormKey',
    mixins: [
      FormEntity,
    ],
    components: {
      EntityButtons,
      EntityInput,
      EntityText,
    },
    data() {
      return {
        object: 'Key',
        commonFields: ['name', 'type', 'key'],
        typeButtons: [
          {value: 'ssh', text: 'SSH'},
          {value: 'sftp', text: 'SFTP'},
        ],
        defaultButtons: [
          {value: true, text: 'Yes'},
          {value: false, text: 'No'},
        ],
      }
    },
    watch: {
      'entity.type'(newType, oldType) {
        // if there's an old entity
        if (oldType) {
          this.createEntity({default: this.entity.type === 'sftp' ? false : this.entity.default})
        }
      },
    },
  }
</script>
